import { zodResolver } from '@hookform/resolvers/zod';
import { forgotPasswordSchema } from '@i9portal/shared';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router';
import { Alert } from '../../components/alert';
import { ErrorMessage } from '../../components/error-state';
import { Field, fieldA11y } from '../../components/field';
import { useDocumentTitle } from '../../hooks/use-document-title';
import { authApi } from '../../lib/api/endpoints/auth';

export function ForgotPasswordPage() {
  useDocumentTitle('Recuperar senha');
  const [sent, setSent] = useState(false);
  const [submitError, setSubmitError] = useState<unknown>(null);
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({ resolver: zodResolver(forgotPasswordSchema), defaultValues: { email: '' } });

  const onSubmit = handleSubmit(async (values) => {
    setSubmitError(null);
    try {
      await authApi.forgotPassword(values);
      setSent(true);
    } catch (error) {
      setSubmitError(error);
    }
  });

  return (
    <>
      <h1 className="public__title">Recuperar senha</h1>
      {sent ? (
        <Alert tone="success" title="Verifique seu e-mail">
          Se o endereço informado estiver cadastrado, você receberá um link para redefinir a senha.
          O link expira em pouco tempo; verifique também a caixa de spam.
        </Alert>
      ) : (
        <form className="stack" onSubmit={onSubmit} noValidate>
          <p className="muted">
            Informe o e-mail cadastrado para receber o link de redefinição de senha.
          </p>
          <Field label="E-mail" htmlFor="forgot-email" error={errors.email?.message} required>
            <input
              type="email"
              className="input"
              autoComplete="email"
              autoFocus
              {...fieldA11y('forgot-email', errors.email?.message)}
              {...register('email')}
            />
          </Field>
          {submitError ? <ErrorMessage error={submitError} /> : null}
          <button type="submit" className="btn btn--primary btn--block" disabled={isSubmitting}>
            {isSubmitting ? 'Enviando…' : 'Enviar link'}
          </button>
        </form>
      )}
      <p className="public__links">
        <Link to="/login">Voltar para o login</Link>
      </p>
    </>
  );
}
